import { RevTabsType } from "@revmatics/catalyst";

export const manageCreatorsTabsData: RevTabsType = [
  { id: "creators_view", title: "Creators" },
  { id: "hidden_creators_view", title: "Hidden Creators" },
];
